import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginLeft: 50,
    marginRight: 50,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 20,
      marginRight: 20,
    },
    zIndex: 1,
    "& .MuiAutocomplete-clearIndicator": {
      marginRight: "4px",
      [theme.breakpoints.down("xs")]: {
        right: "11px",
        height: "35px",
        width: "35px",
        top: "-4px",
        backgroundColor: "#fff",
      },
    },
    "& .MuiInput-underline:before": {
      border: "0px !important",
      borderBottom: "0 !important",
    },
    "& .MuiAutocomplete-input": {
      padding: "4px 4px 2px !important",
      [theme.breakpoints.down("xs")]: {
        padding: "4px 4px 3px !important",
      },
    },
    "& .MuiAutocomplete-inputRoot": {
      height: "40px",
      padding: "0px 10px",
    },
    "& .MuiAutocomplete-endAdornment": {
      right: "3px",
      [theme.breakpoints.down("md")]: {
        right: "5px !important",
      },
      [theme.breakpoints.down("sm")]: {
        right: "12px !important",
      },
      [theme.breakpoints.down("xs")]: {
        right: "15px !important",
        display: "none",
      },
    },
    "& .MuiInput-underline.Mui-disabled:before": {
      borderBottomStyle: "none",
    },
  },
  rootDisplay: {
    flexGrow: 1,
    // marginRight: '15px',
    border: "1px solid #FF5903",
    borderRadius: "50px",
    padding: "0px",
    position: "relative",
    boxShadow: "0 3px 6px rgb(187 131 83 / 25%)",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.up("xl")]: {
      marginRight: "0px",
    },
    [theme.breakpoints.up("lg")]: {
      marginRight: "0px",
    },
  },
  gapSpaceHeader: {
    padding: "0 0 0 10px",
    height: "40px",
    alignItems: "center",
    display: "flex",
    [theme.breakpoints.down("md")]: {
      padding: "0 0 0 10px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 0 10px",
    },
  },

  title: {
    fontFamily: "Gilroy-ExtraBold, serif",
    color: "#000",
    fontSize: "45px",
    [theme.breakpoints.down("md")]: {
      fontSize: "30px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
    },
  },

  subtitle: {
    margin: "20px 0px 30px 0px",
    fontFamily: "Gilroy-Light, serif",
    color: "#000",
    fontSize: "22px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
  spanText: {
    color: "#D62828",
  },
  icon: {},
  noBorder: {
    border: "0",
  },
  input: {
    "& > label": {
      paddingLeft: "1.5em !important",
    },
    "& > div > input": {
      paddingLeft: "1.4em !important",
    },
  },
  paper: {
    padding: "40px 50px 50px 50px",
    boxShadow: "0 3px 11px rgb(0 0 0 / 16%)",
    textAlign: "center",
    borderRadius: "50px",
    opacity: "93%",
    [theme.breakpoints.down("md")]: {
      padding: "20px 25px 25xp 25px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "20px 25px 25xp 25px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "20px 25px 25xp 25px",
    },
  },

  gpsIcon: {
    color: "#ff5903",
    position: "absolute",
    borderLeftColor: "3%",
  },
  gpsIconDisabled: {
    position: "absolute",
    borderLeftColor: "3%",
  },
  searchIcon: {
    color: "#ff5903",
  },

  outlineOne: {
    borderRadius: "5px",
    border: "2px solid #ff5903",
    padding: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.up("sm")]: {
      height: "6.5vh",
    },
    [theme.breakpoints.up("lg")]: {
      height: "6.5vh",
    },
  },
  // formControlOne: {
  //   [theme.breakpoints.down('xs')]: {
  //     display: 'none',
  //   },
  // },
  formControlTwo: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },

  outlineOnePhone: {
    [theme.breakpoints.down("xs")]: {
      borderRadius: "10px 10px 10px 10px",
      border: "2px solid #ff5903",
      height: "7vh",
      padding: theme.spacing(2),
    },
  },
  outlineTwo: {
    border: "2px solid #ff5903",
    // padding: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      borderRadius: "50px 50px 50px 50px",
    },
    [theme.breakpoints.up("sm")]: {
      height: "5vh",
    },
    [theme.breakpoints.up("lg")]: {
      // height: '7vh',
    },
  },
  searchContainer: {
    border: "1px solid #FF5903",
    borderRadius: "50px",
    padding: "0px",
    position: "relative",
    boxShadow: "0 3px 6px rgb(187 131 83 / 25%)",
    height: "60px",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      border: "0px",
      boxShadow: "none",
      borderRadius: "0",
      height: "auto",
      display: "table",
      paddingLeft: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "50px",
      paddingLeft: "5px",
    },
    [theme.breakpoints.down("md")]: {
      height: "50px",
      paddingLeft: "5px",
    },
  },
  Searchinput: {
    borderLeft: "1px solid #F95919",
    paddingLeft: "14px",
    border: "none",
    borderRadius: "0px",

    [theme.breakpoints.down("md")]: {
      height: "40px",
      paddingLeft: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "40px",
      paddingLeft: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      border: "0px",
      paddingLeft: "10px",
    },
  },
  gapSpace: {
    padding: "0px 0px 0px 14px",
    [theme.breakpoints.down("md")]: {
      height: "40px",
      padding: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "40px",
      padding: "0px",
    },

    [theme.breakpoints.down("xs")]: {
      border: "1px solid #FF5903",
      boxShadow: "0 3px 6px rgb(187 131 83 / 25%)",
      borderRadius: "50px",
      marginBottom: "10px",
      fontSize: "14px",
      height: "40px",
      padding: "0px 0px 0px 4px",
    },
  },
  buttonPadding: {
    [theme.breakpoints.down("xs")]: {
      padding: "0",
    },
  },

  button: {
    width: "60px",
    backgroundColor: "#ff5903",
    color: "#fff",
    fontFamily: "Gilroy-ExtraBold, serif",
    textTransform: "capitalize",
    position: "absolute",
    top: "0",
    bottom: "0",
    right: "0",
    borderRadius: "0 50px 50px 0",
    height: "59px",
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
    [theme.breakpoints.down("md")]: {
      height: "49px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "49px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "45px",
      position: "absolute",
      padding: "0",
      right: "0",
      bottom: "10px",
      top: "unset",
      height: "40px",
    },
  },
  buttonTwo: {
    height: "40px",
    width: "48px",
    borderRadius: "0 50px 50px 0",
    color: "#ffff",
    backgroundColor: "#f95919",
    position: "absolute",
    right: "0",
    [theme.breakpoints.down("md")]: {
      width: "45px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "40px",
    },
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
  },
  borderEnabled: {
    border: "0",
    "& .MuiInput-underline:before": {
      border: "0px !important",
      borderBottom: "0 !important",
    },
    "& label.Mui-focused": {
      color: "#e45826",
      border: "0",
    },
    "& .MuiInput-underline:after": {
      border: "0",
    },
    "& .MuiOutlinedInput-root": {
      border: "0",
      "& fieldset": {
        border: "0",
      },
      "&:hover fieldset": {
        border: "0",
      },
      "&.Mui-focused fieldset": {
        border: "0",
      },
    },
  },
  borderDisabled: {
    "& > div": {
      border: "0px",
    },
    "& .MuiOutlinedInput-root": {
      border: "0px",
      "&:hover fieldset": {},
    },
    "& .MuiInput-underline.Mui-disabled:before": {
      borderBottomStyle: "none",
    },
  },
}));

export const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#e45826",
    },
    "& .MuiInput-underline:after": {
      border: "0",
    },
    "& .MuiOutlinedInput": {
      border: "0",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
      border: "0",

      "& fieldset": {
        border: "0",
      },
      "&:hover fieldset": {
        border: "0",
      },
      "&.Mui-focused fieldset": {
        border: "0",
      },
    },
  },
  borderDisabled: {
    "& .MuiOutlinedInput-root": {
      border: "0",

      "&:hover fieldset": {
        borderColor: "#ffff",
      },
    },
  },
})(TextField);
